export const CROSS_SELL_SEEN_KEY = "dtf_atc_crosssell_seen_v1";

export type BogoVariant = "hero" | "compact" | "none";

export const decideBogoVariant = ({
  seen,
  winner
}: {
  seen: boolean;
  winner: string | null | undefined;
}): BogoVariant => {
  if (winner !== "bogo") return "none";
  return seen ? "compact" : "hero";
};

export const getCrossSellSeen = (): boolean => {
  try {
    return window.sessionStorage.getItem(CROSS_SELL_SEEN_KEY) === "1";
  } catch {
    return false;
  }
};

export const setCrossSellSeen = (): void => {
  try {
    window.sessionStorage.setItem(CROSS_SELL_SEEN_KEY, "1");
  } catch {
    // sessionStorage unavailable — fall back to "unseen" on next read.
  }
};
